import { Stack, Typography } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowRight } from "@fortawesome/pro-regular-svg-icons"
import { makeStyles } from "tss-react/mui"

import { useMoney } from "../../../../../currency/useMoney"

import { getPriceChangeDirection, PreviewRow, PriceChangeDirection } from "./adjustPricesLib"

const useStyles = makeStyles()((theme) => ({
    row: {
        padding: ".75rem 1rem",
        borderRadius: ".5rem",
        background: theme.palette.tailwind.slate[50],
    },
    name: {
        color: theme.palette.tailwind.slate[600],
    },
    current: {
        color: theme.palette.tailwind.slate[400],
    },
    next: {
        fontWeight: 700,
    },
    increase: {
        color: theme.palette.success.dark,
    },
    reduction: {
        color: theme.palette.error.dark,
    },
    unchanged: {
        color: theme.palette.tailwind.slate[400],
    },
}))

type AdjustmentExampleRowProps = Readonly<{
    example: PreviewRow
}>

export function AdjustmentExampleRow({ example }: AdjustmentExampleRowProps) {
    const { classes, cx } = useStyles()
    const moneyFactory = useMoney({})

    const directionClasses: Record<PriceChangeDirection, string> = {
        [PriceChangeDirection.INCREASE]: classes.increase,
        [PriceChangeDirection.REDUCTION]: classes.reduction,
        [PriceChangeDirection.UNCHANGED]: classes.unchanged,
    }
    // rounding can push a price the other way, so the colour follows the actual difference
    const directionClass = directionClasses[getPriceChangeDirection(example)]

    return (
        <Stack direction="row" alignItems="center" justifyContent="space-between" className={classes.row}>
            <Typography variant="body2" className={classes.name}>
                {example.productName}
            </Typography>

            <Stack direction="row" alignItems="center" spacing=".75rem">
                <Typography variant="body2" className={classes.current}>
                    {moneyFactory.format(example.current)}
                </Typography>
                <FontAwesomeIcon icon={faArrowRight} className={directionClass} />
                <Typography variant="body1" className={cx(classes.next, directionClass)}>
                    {moneyFactory.format(example.next)}
                </Typography>
            </Stack>
        </Stack>
    )
}
